import LineBehavior from './LineBehavior';

export default class LinesController {
	constructor(scene, controls, linesData, lineColor, reels, lineButtons) {
		this.scene = scene;
		this.reels = reels;
		if (linesData && linesData.length > 0) this.linesData = linesData;
		else this.linesData = this.getAllPossibleLines();
		this.lineColor = lineColor;
		this.lineButtons = lineButtons; // optional
		this.controls = controls;
		this.create();
	}

	create() {
		this.lines = [];
		for (var i = 0; i < this.linesData.length; i++) {
			var lineBehavior = new LineBehavior(
				this.scene,
				this,
				this.linesData[i],
				this.lineButtons ? this.lineButtons[i] : null,
				i + 1,
				this.lineColor
			);
			this.lines.push(lineBehavior);
		}
		console.log('this.linesData : ' + this.linesData + '; length: ' + this.linesData.length);
	}

	setControlActivity(activity) {
		if (this.lineButtons)
			this.lineButtons.forEach(lb => {
				lb.interactable = activity;
			});
	}

	selectAllLines(show) {
		if (this.createAllPossibleLines && this.controls.selectedLinesCount > 0) return; //avoid max bet
		if (this.lines == null || this.lines.length == 0) return;
		if (this.controls != null) this.controls.setSelectedLinesCount(this.lines.length, show);
	}

	lineButton_Click(line) {
		var count = 1;
		if (line.isSelected) {
			count = line.number - 1;
		} else {
			count = line.number;
		}
		console.log('line: ' + line.number + '; count' + count + '; iselected:' + line.isSelected);
		if (this.controls != null) this.controls.setSelectedLinesCount(count, true);
	}

	hideAllLines() {
		this.lines.forEach(l => {
			l.lineFlashing(false);
			l.setLineVisible(false);
		});
	}

	changeSelectedLinesHandler(newCount, show) {
		newCount = Math.min(newCount, this.lines.length);
		for (var i = 0; i < this.lines.length; i++) {
			if (i < newCount) {
				if (!this.lines[i].isSelected) {
					this.lines[i].select(show);
				}
			} else {
				if (this.lines[i].isSelected) {
					this.lines[i].isSelected.deselect();
				}
			}
		}
	}

	getAllPossibleLines() {
		var maxCounterValues = [];
		this.reels.forEach(r => {
			maxCounterValues.push(r.windowsCount - 1);
		});
		var cC = new ComboCounter(maxCounterValues);
		var newLinesData = [];
		var i = 0;
		while (cC.nextCombo()) {
			newLinesData.push([...cC.combo]);
		}
		return newLinesData;
	}
}
